// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Icon$OrcaPaymentPage from "./Icon.bs.js";
import * as RenderIf$OrcaPaymentPage from "./Components/RenderIf.bs.js";
import * as CardUtils$OrcaPaymentPage from "./CardUtils.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "./Utilities/JotaiAtoms.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "./Utilities/PaymentUtils.bs.js";
import * as PaymentMethodCollectUtils$OrcaPaymentPage from "./Utilities/PaymentMethodCollectUtils.bs.js";

function FormViewTabs(props) {
  let renderAddressForm = props.renderAddressForm;
  let __defaultOptionsLimitInTabLayout = props.defaultOptionsLimitInTabLayout;
  let tabsView = props.tabsView;
  let handleSubmit = props.handleSubmit;
  let primaryTheme = props.primaryTheme;
  let availablePaymentMethodTypes = props.availablePaymentMethodTypes;
  let __defaultOptionsLimitInTabLayout_value = __defaultOptionsLimitInTabLayout !== undefined ? __defaultOptionsLimitInTabLayout : PaymentMethodCollectUtils$OrcaPaymentPage.defaultOptionsLimitInTabLayout;
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  let localeString = match.localeString;
  let payoutDynamicFields = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.payoutDynamicFieldsAtom);
  let formData = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.formDataAtom);
  let match$1 = Jotai.useAtom(JotaiAtoms$OrcaPaymentPage.paymentMethodTypeAtom);
  let setActivePmt = match$1[1];
  let activePmt = match$1[0];
  let match$2 = Jotai.useAtom(JotaiAtoms$OrcaPaymentPage.validityDictAtom);
  let setValidityDict = match$2[1];
  let validityDict = match$2[0];
  let paymentMethodListValue = Jotai.useAtomValue(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  let supportedCardBrands = React.useMemo(() => PaymentUtils$OrcaPaymentPage.getSupportedCardBrands(paymentMethodListValue), [paymentMethodListValue]);
  let match$3 = React.useState(() => availablePaymentMethodTypes);
  let setOrderedPmts = match$3[1];
  let orderedPmts = match$3[0];
  let match$4 = React.useState(() => false);
  let setFormSubmitted = match$4[1];
  let formSubmitted = match$4[0];
  let viewStack = React.useRef([tabsView]);
  let push = newState => {
    viewStack.current = Belt_Array.concatMany([
      viewStack.current,
      [newState]
    ]);
  };
  let pop = () => {
    let match = viewStack.current.length;
    if (match !== 0 && match !== 1) {
      viewStack.current.pop();
      return;
    }
  };
  let get = () => Core__Option.getOr(viewStack.current[viewStack.current.length - 1 | 0], tabsView);
  let match$5 = React.useState(() => get());
  let setViewState = match$5[1];
  let view = match$5[0];
  React.useEffect(() => {
    Core__Option.map(availablePaymentMethodTypes[0], pmt => setActivePmt(param => pmt));
    setOrderedPmts(param => availablePaymentMethodTypes);
  }, [availablePaymentMethodTypes]);
  let handleTabSelection = newPmtStr => {
    Core__Option.map(orderedPmts.find(pmt => PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodTypeLabel(pmt) === newPmtStr), newPmt => {
      if (orderedPmts.indexOf(newPmt) >= __defaultOptionsLimitInTabLayout_value) {
        let ordList = Core__Array.reduceWithIndex(availablePaymentMethodTypes, [], (acc, pmt, i) => {
          if (i === (__defaultOptionsLimitInTabLayout_value - 1 | 0)) {
            acc.push(newPmt);
          }
          if (pmt !== newPmt) {
            acc.push(pmt);
          }
          return acc;
        });
        setOrderedPmts(param => ordList);
      }
      setActivePmt(param => newPmt);
      return newPmt;
    });
  };
  let renderSaveButton = onClickHandler => JsxRuntime.jsx("button", {
    children: localeString.formSaveText,
    className: "min-w-full mt-10 text-lg font-semibold px-2.5 py-1.5 text-white rounded",
    style: {
      backgroundColor: primaryTheme
    },
    onClick: onClickHandler
  });
  let renderPmtTabs = activePmt => {
    let key = PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodTypeLabel(activePmt);
    let activeStyles_borderColor = primaryTheme;
    let activeStyles_borderWidth = "2px";
    let activeStyles_color = primaryTheme;
    let activeStyles = {
      borderColor: activeStyles_borderColor,
      borderWidth: activeStyles_borderWidth,
      color: activeStyles_color
    };
    let defaultStyles_borderColor = "#9A9FA8";
    let defaultStyles_borderWidth = "1px";
    let defaultStyles_color = primaryTheme;
    let defaultStyles = {
      borderColor: defaultStyles_borderColor,
      borderWidth: defaultStyles_borderWidth,
      color: defaultStyles_color
    };
    let hiddenTabs = Core__Array.reduceWithIndex(orderedPmts, [], (options, pmt, i) => {
      if (i >= __defaultOptionsLimitInTabLayout_value) {
        let key = PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodTypeLabel(pmt);
        options.push(JsxRuntime.jsx("option", {
          children: key,
          className: "text-black bg-white hover:bg-gray-100",
          value: key
        }, i.toString()));
      }
      return options;
    });
    let visibleTabs = Core__Array.reduceWithIndex(orderedPmts, [], (items, pmt, i) => {
      if (i < __defaultOptionsLimitInTabLayout_value) {
        let key = PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodTypeLabel(pmt);
        items.push(JsxRuntime.jsxs("div", {
          children: [
            PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodTypeIcon(pmt),
            JsxRuntime.jsx("div", {
              children: key,
              className: "ml-2.5"
            })
          ],
          className: "flex w-full items-center rounded border-0 px-2.5 py-1.5 mr-2.5 cursor-pointer hover:bg-jp-gray-50",
          style: key === PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodTypeLabel(activePmt) ? activeStyles : defaultStyles,
          onClick: param => handleTabSelection(key)
        }, i.toString()));
      }
      return items;
    });
    return JsxRuntime.jsxs("div", {
      children: [
        visibleTabs,
        JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
          condition: orderedPmts.length > __defaultOptionsLimitInTabLayout_value,
          children: JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Icon$OrcaPaymentPage.make, {
                name: "arrow-down",
                size: 10,
                className: "absolute z-10 pointer translate-x-2.5 translate-y-3.5 pointer-events-none"
              }),
              JsxRuntime.jsxs("select", {
                children: [
                  JsxRuntime.jsx("option", {
                    children: key,
                    disabled: true,
                    value: key
                  }, key),
                  hiddenTabs
                ],
                className: "h-full relative rounded border border-solid border-jp-gray-700 py-1.5 cursor-pointer bg-white text-transparent w-8 hover:bg-jp-gray-50",
                value: key,
                onChange: ev => handleTabSelection(ev.target.value)
              })
            ],
            className: "relative"
          })
        })
      ],
      className: "flex flex-row w-full"
    });
  };
  let renderInfoTemplate = (label, value, uniqueKey) => JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: label,
        className: "w-4/10 text-jp-gray-800 text-sm min-w-40 text-end"
      }),
      JsxRuntime.jsx("div", {
        children: "",
        className: "mx-2.5 h-4 w-0.5 bg-jp-gray-300"
      }),
      JsxRuntime.jsx("div", {
        children: value,
        className: "w-6/10 text-sm min-w-40"
      })
    ],
    className: "flex flex-row items-center"
  }, uniqueKey);
  let tmp;
  if (typeof view !== "object") {
    let contentHeaderClasses = "text-xl lg:text-2xl font-semibold mt-5";
    let key = PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodTypeLabel(activePmt);
    let onSaveHandler = () => {
      let match = Core__Option.getOr(Core__Option.map(payoutDynamicFields.address, addressFields => Core__Array.reduce(addressFields, [
        {},
        true
      ], (param, field) => {
        let fieldValidity = param[0];
        let key = PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldKey({
          TAG: "BillingAddress",
          _0: field.fieldType
        });
        let value = Core__Option.getOr(formData[key], "");
        let validity = PaymentMethodCollectUtils$OrcaPaymentPage.calculateValidity({
          TAG: "BillingAddress",
          _0: field.fieldType
        }, value, "", false);
        fieldValidity[key] = validity;
        return [
          fieldValidity,
          param[1] && Primitive_object.notequal(validity, false)
        ];
      })), [
        Object.assign({}, validityDict),
        true
      ]);
      let match$1 = Core__Array.reduce(payoutDynamicFields.payoutMethodData, [
        match[0],
        match[1]
      ], (param, field) => {
        let fieldValidity = param[0];
        let key = PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldKey({
          TAG: "PayoutMethodData",
          _0: field.fieldType
        });
        let value = Core__Option.getOr(formData[key], "");
        let validCardBrand = CardUtils$OrcaPaymentPage.getFirstValidCardSchemeFromPML(value, Core__Option.getOr(supportedCardBrands, []));
        let newCardBrand = validCardBrand !== undefined ? validCardBrand : CardUtils$OrcaPaymentPage.getCardBrand(value);
        let validity = PaymentMethodCollectUtils$OrcaPaymentPage.calculateValidity({
          TAG: "PayoutMethodData",
          _0: field.fieldType
        }, value, newCardBrand, false);
        fieldValidity[key] = validity;
        return [
          fieldValidity,
          param[1] && Primitive_object.notequal(validity, false)
        ];
      });
      let fieldValidity = match$1[0];
      setValidityDict(param => fieldValidity);
      if (match$1[1]) {
        Core__Option.map(PaymentMethodCollectUtils$OrcaPaymentPage.formPaymentMethodData(formData, fieldValidity, payoutDynamicFields), pmd => {
          let view = {
            TAG: "FinalizeView",
            _0: [
              activePmt,
              pmd
            ]
          };
          setViewState(param => {
            push(view);
            return view;
          });
        });
        return;
      }
    };
    let tmp$1;
    switch (activePmt.TAG) {
      case "Card" :
        tmp$1 = localeString.formHeaderEnterCardText;
        break;
      case "BankRedirect" :
      case "BankTransfer" :
        tmp$1 = localeString.formHeaderBankText(key);
        break;
      case "Wallet" :
        tmp$1 = localeString.formHeaderWalletText(key);
        break;
    }
    tmp = JsxRuntime.jsxs("div", {
      children: [
        renderPmtTabs(activePmt),
        JsxRuntime.jsx("div", {
          children: tmp$1,
          className: contentHeaderClasses
        }),
        props.renderPayoutMethodForm(payoutDynamicFields.payoutMethodData),
        Core__Option.getOr(Core__Option.map(payoutDynamicFields.address, addressFields => {
          let fieldsToCollect = addressFields.filter(addressField => addressField.value === undefined);
          if (fieldsToCollect.length <= 0) {
            return null;
          }
          let formFields = renderAddressForm(addressFields);
          return JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [
              JsxRuntime.jsx("div", {
                children: localeString.billingDetailsText,
                className: `mb-2.5 ` + contentHeaderClasses
              }),
              formFields
            ]
          });
        }), null),
        renderSaveButton(param => onSaveHandler())
      ]
    });
  } else {
    let match$6 = view._0;
    let formFields = match$6[1];
    let pmt = match$6[0];
    let pm = PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodForPmt(pmt);
    tmp = JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("img", {
                  className: "h-6 w-auto",
                  alt: "",
                  src: "merchantLogo"
                }),
                JsxRuntime.jsx("div", {
                  children: localeString.formHeaderReviewTabLayoutText(PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodTypeLabel(pmt)),
                  className: "ml-1.5"
                })
              ],
              className: "flex flex-row items-center mb-2.5 text-xl font-semibold"
            }),
            formFields.map((field, i) => {
              let value = field[1];
              let field$1 = field[0];
              if (field$1.TAG === "BillingAddress") {
                return null;
              }
              let fieldType = field$1._0.fieldType;
              if (typeof fieldType !== "object") {
                return renderInfoTemplate(PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldLabel({
                  TAG: "PayoutMethodData",
                  _0: fieldType
                }, localeString), value, i.toString());
              }
              if (fieldType._0 !== "CardExpMonth") {
                return null;
              }
              let expiryYear = Core__Option.getOr(Core__Option.flatMap(formData[PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldKey({
                    TAG: "PayoutMethodData",
                    _0: {
                      TAG: "CardExpDate",
                      _0: "CardExpYear"
                    }
                  })], value => Core__Option.map(value.split("/")[1], year => `20` + year.trim())), "");
              let expiryValue = value + ` / ` + expiryYear;
              return renderInfoTemplate(PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldLabel({
                TAG: "PayoutMethodData",
                _0: {
                  TAG: "CardExpDate",
                  _0: "CardExpMonth"
                }
              }, localeString), expiryValue, i.toString());
            })
          ],
          className: "flex flex-col"
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("img", {
              className: "h-3 w-auto mr-1.5",
              alt: "",
              src: "merchantLogo"
            }),
            localeString.formFundsCreditInfoText(PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodLabel(pm).toLowerCase())
          ],
          className: "flex flex-row items-center min-w-full my-5 px-2.5 py-1.5 text-xs border border-solid border-blue-200 rounded bg-blue-50"
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("button", {
              children: localeString.formEditText,
              className: "w-full px-2.5 py-1.5 rounded border border-solid",
              style: {
                borderColor: primaryTheme,
                color: primaryTheme
              },
              disabled: formSubmitted,
              onClick: param => {
                let countOpt;
                let count = countOpt !== undefined ? countOpt : 1;
                setViewState(param => {
                  for (let _for = 1; _for <= count; ++_for) {
                    pop();
                  }
                  return get();
                });
              }
            }),
            JsxRuntime.jsx("button", {
              children: formSubmitted ? localeString.formSubmittingText : localeString.formSubmitText,
              className: "w-full px-2.5 py-1.5 text-white rounded ml-2.5",
              style: {
                backgroundColor: primaryTheme
              },
              disabled: formSubmitted,
              onClick: param => {
                setFormSubmitted(param => true);
                handleSubmit([
                  pmt,
                  formFields
                ]);
              }
            })
          ],
          className: "flex my-5 text-lg font-semibold w-full"
        })
      ]
    });
  }
  return JsxRuntime.jsx("div", {
    children: tmp,
    className: "w-full max-w-[520px]"
  });
}

let make = FormViewTabs;

let $$default = FormViewTabs;

export {
  make,
  $$default as default,
}
/* jotai Not a pure module */
